import React, { createContext, useContext } from 'react';
import { emptyPreInstallationData, usePreInstallationData } from '../hooks/usePreInstallationData';
import { isMobile } from '../utils/general';
import { useIsFinishedInstalling } from '../hooks/useIsInstallingFinished';
import { useModalsAndWindow } from './ModalsAndWindowContext';
export const InstallerContext = /*#__PURE__*/createContext({
  httpClient: {},
  tenantType: 'SITE',
  appId: '',
  tenantId: '',
  silentInstall: false,
  version: undefined,
  isMobile: false,
  shareUrlId: undefined,
  preInstallationData: emptyPreInstallationData,
  avoidPostInstallation: false,
  setTenantId: () => {},
  isFinishedLoading: false,
  setIsFinishLoading: () => {},
  onProvisionSuccess: () => {},
  onInstallationFailed: () => {},
  onInstallationCompleted: () => {},
  platform: 'STANDALONE',
  versionOverrideId: ''
});
export const useInstallerContext = () => useContext(InstallerContext);
export const InstallerMainContextProvider = _ref => {
  let {
    httpClient,
    appId,
    tenantId,
    setTenantId,
    children,
    version,
    tenantType,
    silentInstall,
    shareUrlId,
    avoidPostInstallation,
    onInstallationCompleted,
    onProvisionSuccess,
    onInstallationFailed,
    onUiInitialLoad,
    platform,
    overrideNavigate,
    MarketingConsentContent,
    versionOverrideId,
    isOneStepInstall,
    preInstallationDataCache
  } = _ref;
  const [isFinishedLoading, setIsFinishLoading] = useIsFinishedInstalling();
  const {
    newWindowHandlers
  } = useModalsAndWindow();
  const preInstallationData = usePreInstallationData({
    appId,
    httpClient,
    version,
    tenantId,
    shareUrlId,
    preInstallationDataCache
  });
  return /*#__PURE__*/React.createElement(InstallerContext.Provider, {
    value: {
      preInstallationData,
      httpClient,
      appId,
      tenantType,
      tenantId,
      silentInstall,
      version,
      isMobile: isMobile(),
      shareUrlId,
      setTenantId,
      avoidPostInstallation,
      isFinishedLoading,
      setIsFinishLoading,
      onInstallationCompleted,
      onProvisionSuccess,
      onInstallationFailed,
      onUiInitialLoad,
      platform,
      overrideNavigate,
      MarketingConsentContent,
      versionOverrideId,
      isOneStepInstall
    }
  }, children, newWindowHandlers.NewWindowPortal);
};
//# sourceMappingURL=InstallerContext.js.map